import App from '@/components/games/edit/App.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { faComment } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { createMyApp } from '@/utils/create_my_app'

// NOTE: games/edit.tsはturboでloadされるので、turbo:loadなどは遅すぎて使えない
(() => {
  const id = 'edit';
  const rawProps = document.getElementById(id)?.getAttribute('data');
  library.add(faTrashCan, faComment)
  if(rawProps) {
    const props = JSON.parse(rawProps);
    const app = createMyApp(App, props);
    app.component('fa', FontAwesomeIcon).
      mount(`#${id}`);
  }
})()
